<div #container class="form-group">
  <div>{{name}} Signature
    <br />
    If you are using a mobile device, please sign using your finger. If on a computer, please sign using your mouse.
  </div>
  <div class="sigPadWrapper">
    <canvas class="signature-pad" id="signature-pad">
    </canvas>
  </div>
  <div>
    @if (enabled) {
      <p-button type="button" icon="pi pi-times" class="hidden-print clear-btn" (click)="clearSignature()" severity="secondary">
      </p-button>
    }
  </div>
  @if (signatureError) {
    <div class="alert alert-danger" role="alert">
      Signature is required
    </div>
  }
</div>